import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

import { useMyUserData } from '../accounts/use-my-user'

import type { NotificationType } from './use-user-preferences'

interface UpdateUserTutorialsData {
  feedTutorial?: boolean
  receivedReferralTutorial?: boolean
  sendReferralTutorial?: boolean
  homeTutorial?: boolean
  weeklyRecapSeen?: boolean
}

export interface UpdateUserPreferencesData {
  referralReceivedNew?: NotificationType[] | null
  referralReceivedTimeBased?: NotificationType[] | null
  referralReceivedApproved?: NotificationType[] | null
  referralReceivedDenied?: NotificationType[] | null
  referralReceivedExpired?: NotificationType[] | null
  referralSentInterested?: NotificationType[] | null
  referralSentDeclined?: NotificationType[] | null
  referralSentTimeBased?: NotificationType[] | null
  chatNewMessage?: NotificationType[] | null
  postsVisibleToConsumer?: boolean
  transactionsVisibleToConsumer?: boolean
}

async function updateUserTutorials(data: UpdateUserTutorialsData): Promise<void> {
  await putRequest('/users/preferences/update', data)
}

export function useUpdateUserTutorials() {
  const queryClient = useQueryClient()
  const { data: user } = useMyUserData()

  return useMutation({
    mutationFn: updateUserTutorials,
    onSuccess: () => {
      queryClient.invalidateQueries(queries.users.me._ctx.tutorials)
      queryClient.invalidateQueries(queries.users.me._ctx.preferences)
      if (user?.id) {
        queryClient.invalidateQueries(queries.users.me._ctx.privacyPreferences(user.id))
      }
    },
  })
}

async function updateUserPreferences(data: UpdateUserPreferencesData): Promise<void> {
  await putRequest('/users/preferences/update', data)
}

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient()
  const { data: user } = useMyUserData()

  return useMutation({
    mutationFn: updateUserPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries(queries.users.me._ctx.tutorials)
      queryClient.invalidateQueries(queries.users.me._ctx.preferences)
      if (user?.id) {
        queryClient.invalidateQueries(queries.users.me._ctx.privacyPreferences(user.id))
      }
    },
  })
}
